module.exports = __webpack_public_path__ + "static/media/phone-trade-sell-mobile.b2e3ede6.png";